import i18n from '@/utils/i18n';
import { useParams } from 'react-router';
import { DashboardLayout } from '../components/DashboardLayout';
import { Button } from 'reactstrap';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { DepositClearingEventAccount } from '../../EventAccounts/components/DepositClearingEventAccount';

type InventoryPageProps = {};

export const EventInventoryPage = (props: InventoryPageProps) => {
  const { eventAccountId, eventId } = useParams<{
    eventAccountId: string;
    eventId: string;
  }>();

  const scrollTo = (direction: 'left' | 'right') => {
    const container = document.querySelector('.events-horizontal-cards-inner');

    if (container) {
      const scrollAmount = 300;
      const currentScroll = container.scrollLeft;

      if (direction === 'left') {
        container.scrollTo({
          left: currentScroll - scrollAmount,
          behavior: 'smooth',
        });
      } else {
        container.scrollTo({
          left: currentScroll + scrollAmount,
          behavior: 'smooth',
        });
      }
    }
  };

  return (
    <DashboardLayout title={i18n.t('EventsDashboard:globalInventory')}>
      {/* Horizonal scrollable cards */}
      <div className="events-horizontal-cards">
        {/* Arrow left and right buttons */}
        <Button
          className="control-button control-button-left"
          onClick={() => scrollTo('left')}
        >
          <FaChevronLeft />
        </Button>
        <Button
          className="control-button control-button-right"
          onClick={() => scrollTo('right')}
        >
          <FaChevronRight />
        </Button>
      </div>

      <h3 className="mt-4">{i18n.t('EventsDashboard:stock')}</h3>
      <DepositClearingEventAccount
        eventAccountId={eventAccountId}
        eventId={eventId}
      />
    </DashboardLayout>
  );
};
